import {
  PORTFOLIO_ACCOUNT_STATUS_OBJ,
  PORTFOLIO_MONEY_ZERO_TOLERANCE,
  PORTFOLIO_QUANTITY_ZERO_TOLERANCE,
  type TPortfolioAccountStatus,
} from "../constants/portfolio.constants";
import { compareCalendarDates } from "./calendar-date";

/** Calendar date of closure, or null/undefined for an account that was never closed. */
export type TPortfolioAccountClosedOn = string | null | undefined;

/** Catalog status at the cutoff: the closure date itself is already "closed". */
export function getPortfolioAccountStatus(
  closedOn: TPortfolioAccountClosedOn,
  cutoff: string,
): TPortfolioAccountStatus {
  return closedOn != null && compareCalendarDates(closedOn, cutoff) <= 0
    ? PORTFOLIO_ACCOUNT_STATUS_OBJ.CLOSED
    : PORTFOLIO_ACCOUNT_STATUS_OBJ.OPEN;
}

/**
 * Whether a write dated `operationDate` may touch the account. Independent of the catalog
 * status: on the closure date the account is "closed" in the catalog yet still accepts
 * operations of that day.
 */
export function isPortfolioAccountAvailableForDate(
  closedOn: TPortfolioAccountClosedOn,
  operationDate: string,
): boolean {
  return closedOn == null || compareCalendarDates(operationDate, closedOn) <= 0;
}

/** Money residue per (account, currency) is a real balance unless it is a finite float artifact. */
export function isPortfolioMoneyZero(amount: number): boolean {
  return Number.isFinite(amount) && Math.abs(amount) <= PORTFOLIO_MONEY_ZERO_TOLERANCE;
}

/** Quantity residue follows the FIFO tolerance, including expected conversion quantities. */
export function isPortfolioQuantityZero(quantity: number): boolean {
  return Number.isFinite(quantity) && Math.abs(quantity) <= PORTFOLIO_QUANTITY_ZERO_TOLERANCE;
}
